import { ContainerClient } from '@azure/storage-blob'
import type { AssetUploadGateway } from '#/domain/assetsLink/AssetUploadGateway'

export class AzureBlobAssetUploadGateway implements AssetUploadGateway {
  async upload(sasUri: string, file: File, folder: string): Promise<void> {
    const containerClient = this.getContainerClient(sasUri)
    const path = `${folder}/${file.name}`
    const blockBlobClient = containerClient.getBlockBlobClient(path)
    await blockBlobClient.uploadData(file)
  }

  private getContainerClient(sasUri: string): ContainerClient {
    let uri = sasUri
    if (process.env.isDev) {
      uri = uri.replace(/azurite/g, '127.0.0.1')
    }
    return new ContainerClient(uri)
  }
}
